import { DashboardSaleSummary } from "../../../types/dashboard.type";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SalePieChart from "../SalePieChart";
import SaleSummarySkeleton from "../Skeleton/SaleSummarySkeleton";

interface SaleSummaryProps {
  summary: DashboardSaleSummary | undefined;
  loading: boolean;
  error: boolean;
}

function LegendDot({ color, label }: { color: string; label: string }) {
  return (
    <Box display="flex" alignItems="center" gap={0.75}>
      <Box
        sx={{
          width: 14,
          height: 14,
          flexShrink: 0,
          borderRadius: "50%",
          bgcolor: color,
        }}
      />
      <Typography variant="body2" fontWeight={500}>
        {label}
      </Typography>
    </Box>
  );
}

export default function SaleSummaryHo({
  summary,
  loading,
  error,
}: SaleSummaryProps) {
  if (loading) return <SaleSummarySkeleton />;

  return (
    <Paper sx={{ height: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 1,
          mb: 2,
        }}
      >
        <Typography variant="body1" fontWeight={600}>
          ประเภทการจ่าย
        </Typography>
        <Box display="flex" flexDirection="column" gap={0.75} alignItems="flex-start">
          <LegendDot color="#73ceea" label="เงินเชื่อ" />
          <LegendDot color="#6066ea" label="เงินสด" />
        </Box>
      </Box>
      {error || !summary ? (
        <Box
          sx={{
            height: 240,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography color="error" fontWeight={500}>
            ไม่สามารถโหลดข้อมูลได้
          </Typography>
        </Box>
      ) : (
        <SalePieChart
          invoiceTotalAmount={summary.credit_total_value}
          cashsaleTotalAmount={summary.cash_total_value}
          hideLegend
        />
      )}
    </Paper>
  );
}
